import Bugsnag from "@bugsnag/js";
import { ANALYTIC_EVENTS, sendAnalytics } from "@/utils/analytics";
import { invalidateRelatedCaches } from "@/modules/loan/store/services/utils/invalidate-related-caches";
import { loanService } from "@/modules/loan/store/services/loan-service";

const patchLoan = loanService.injectEndpoints({
  endpoints: builder => ({
    patchLoan: builder.mutation({
      query: ({ loanId: id, _event, ...patch }) => ({
        url: `loans/${id}`,
        method: "PATCH",
        body: patch,
      }),
      invalidatesTags: (result, error, { loanId: id }) => [
        { type: "Loan", id },
        { type: "Loan", id: "LIST" },
        { type: "LoanLendersHeatMap", id: "LIST" },
      ],
      async onQueryStarted({ loanId, event, loanStatusOrder, ...patch }, { dispatch, queryFulfilled, getState }) {
        const patchResultsLoans = [];
        const state = getState();
        const queriesState = state.loanApi.queries;

        Object.keys(queriesState).forEach(queryKey => {
          if (queryKey.startsWith("getLoans(")) {
            const query = queriesState[queryKey];
            if (query?.data) {
              const patchResult = dispatch(
                loanService.util.updateQueryData("getLoans", query.originalArgs, draft => {
                  const items = draft?.items || draft?.records;
                  if (items) {
                    const loanIndex = items.findIndex(loan => loan.loanId === loanId);
                    if (loanIndex !== -1) Object.assign(items[loanIndex], patch);

                    if (loanStatusOrder && Array.isArray(loanStatusOrder)) {
                      loanStatusOrder.forEach(({ loanId: orderLoanId, index }) => {
                        const orderLoanIndex = items.findIndex(loan => loan.loanId === orderLoanId);
                        if (orderLoanIndex !== -1) items[orderLoanIndex].index = index;
                      });
                    }
                  }
                }),
              );
              patchResultsLoans.push(patchResult);
            }
          }
        });

        const patchResultLoan = dispatch(
          loanService.util.updateQueryData("getLoan", loanId, draft => {
            if (draft) Object.assign(draft, patch);
          }),
        );

        try {
          const { data } = await queryFulfilled;
          sendAnalytics(event || ANALYTIC_EVENTS.LOAN_UPDATED, data);
          invalidateRelatedCaches(dispatch, { includeLoanSummary: true });
        } catch (err) {
          patchResultsLoans.forEach(patchResult => patchResult.undo());
          patchResultLoan.undo();
          Bugsnag.notify(err);
        }
      },
    }),
  }),
  overrideExisting: false,
});

export const { usePatchLoanMutation } = patchLoan;

